export default {"src":"/_next/static/media/search_list_icon.2e14d89d.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};